<template>
  <div class="m-card-pay">
    <van-dialog
      v-model="dialogModel"
      show-cancel-button
      :confirmButtonText="$t('confirm.msg_fail_confirm')"
      :cancelButtonText="$t('confirm.msg_fail_cancel')"
      :before-close="onPayment"
    >
      <van-row class="card-pay-dialog">
        <div class="card-dropdown">
          <van-dropdown-menu>
            <van-dropdown-item
              :options="bankCodeList"
              v-model="payInfo.BeneficiaryBankCode"
            />
          </van-dropdown-menu>
        </div>
        <van-field
          type="text"
          placeholder="Beneficiary Cell Phone"
          class="card-pay-dialog-card"
          v-model="payInfo.BeneficiaryCellPhone"
        />
        <van-field
          type="text"
          placeholder="Beneficiary Email"
          class="card-pay-dialog-card"
          v-model="payInfo.BeneficiaryEmail"
        />
        <van-field
          type="text"
          class="card-pay-dialog-card"
          placeholder="Beneficiary ID"
          v-model="payInfo.BeneficiaryID"
        >
          <template #left-icon>
            <span style="margin-right: 4px;">V</span>
          </template>
        </van-field>
        <van-field
          type="text"
          placeholder="Beneficiary Name"
          v-model="payInfo.BeneficiaryName"
        />
      </van-row>
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import multicurrencyMixin from "../../../mixins/multicurrency";
export default {
  name: "SaveCardPay",
  mixins: [multicurrencyMixin],
  props: {
    payMode: {},
    payType: {},
    paymentId: {
      type: [String, Number],
      default: ""
    },
    dialogPopup: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  watch: {
    dialogPopup(val) {
      if (val) this.loadBankCodeList();
    }
  },
  computed: {
    ...mapState(["system", "user"]),
    i18n() {
      return this.$t("confirm");
    },
    dialogModel: {
      get() {
        return this.dialogPopup
      },
      set(val) {
        this.$emit('update:dialogPopup', val)
      }
    }
  },
  data() {
    return {
      isAreaView: false,
      payInfo: {
        show: false,
        BeneficiaryBankCode: "0",
        BeneficiaryCellPhone: "",
        BeneficiaryEmail: "",
        BeneficiaryID: "",
        BeneficiaryName: ""
      },
      bankCodeList: []
    };
  },
  methods: {
    // SaveCardPay 支付
    SaveCardPay(done) {
      const fieldValues = { ...this.payInfo };
      const regex = /^0(212|412|414|416|422|424|426)\d{7}$/;
      if (fieldValues.BeneficiaryBankCode === '0') {
        this.$toast(this.$t("bncPay").please_select_bank);
      } else if (!fieldValues.BeneficiaryCellPhone) {
        this.$toast(this.$t("bncPay").please_enter_phone);
      } else if (!fieldValues.BeneficiaryID) {
        this.$toast(`${this.$t("msg").please_enter} BeneficiaryID`);
      } else if (!fieldValues.BeneficiaryName) {
        this.$toast(`${this.$t("msg").please_enter} BeneficiaryName`);
      } else if (!regex.test(fieldValues.BeneficiaryCellPhone)) {
        this.$toast('Teléfono de Origen (Ej: 04141234567)');
      } else {
        this.payInfo = {
          ...fieldValues,
          BeneficiaryBankCode: "0",
          BeneficiaryCellPhone: "",
          BeneficiaryEmail: "",
          BeneficiaryID: "",
          BeneficiaryName: ""
        };
        this.$emit("onPayment", {
          show: false,
          ...fieldValues,
          BeneficiaryID: `V${fieldValues.BeneficiaryID}`,
          BeneficiaryCellPhone: `+58${fieldValues.BeneficiaryCellPhone}`
        });
        return done();
      }
      return done(false);
    },
    // 确认支付
    onPayment(action, done) {
      if (action === "confirm") {
        this.SaveCardPay(done);
      } else if (action === "cancel") {
        this.$emit("onPayment", { show: false, cancel: true });
        done();
      }
    },
    // 加载BankCode列表
    async loadBankCodeList() {
      this.$loading(true);
      var res = await this.multicurrencyBanks(this.paymentId);
      this.$loading(false);
      // this.payMode === res.paymentType &&
      if (res.bankList) {
        var bankCodeList = res.bankList.map(item => {
          return { value: item.Code, text: `${item.Name}(${item.Code})` };
        });
        bankCodeList.unshift({ value: "0", text: `Please select` });
        this.bankCodeList = bankCodeList;
      }
    }
  },
  mounted() {},
  created() {
    if (this.user && this.user.email) {
      this.payInfo.email = this.user.email;
    }
  }
};
</script>

<style lang="less" scoped>
.pay-popup {
  margin: 64px 0 32px;
  padding: 24px 46px;
  &-number {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    padding-left: 24px;
    border-radius: 16px;
    border: 1px solid #ccc;
    overflow: hidden;
  }
  &-phone {
    font-size: 32px;
  }
}
.card-pay-dialog {
  width: 90%;
  margin: 64px auto 42px;
  .van-cell {
    border: 1px solid #ebedf0;
    border-radius: 12px;
  }
  &-card {
    margin: 28px 0;
  }
}
</style>
<style lang="less">
.card-dropdown {
  position: relative;
  margin: 0 auto;
  .van-dropdown-item--down {
    top: 180px !important;
  }
}
</style>
